<template>
    <div class="grid">
        <div class="col-12">
            <div class="card">
                theme {{perf}}
                <DataTable :value="themes" class="p-datatable-sm" responsiveLayout="scroll" showGridlines stripedRows
                :lazy="true" :paginator="true" :rows="10" ref="dt" dataKey="id"
                :totalRecords="totalRecords" :loading="loading" @page="onPage($event)" @sort="onSort($event)"
                paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown" :rowsPerPageOptions="[10,25,50,75,100]"
                currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
                selectionMode="single"
                v-model:filters="filters" @filter="onFilter($event)" filterDisplay="row">
                <Column field="id" header="No" :sortable="true"></Column>
                <Column field="i_date" header="レコード入力日" :sortable="true"></Column>
                <Column field="theme_name" header="テーマ名" filterField="theme_name" filterMatchMode="contains" ref="theme_name" :sortable="true" :style="{'min-width': '10rem'}">
                    <template #filter="{filterModel,filterCallback}">
                    <InputText type="text" v-model="filterModel.value" @keydown.enter="filterCallback()" class="p-column-filter" placeholder="名称" />
                    </template>
                </Column>                
                <Column field="meigara_name_list_en" header="銘柄リストen" :sortable="true"></Column>
                <Column field="meigara_name_list_ja" header="銘柄リストja" filterField="meigara_cd_list" filterMatchMode="contains" ref="meigara_name_list_ja" :sortable="true" :style="{'min-width': '10rem'}">
                    <template #filter="{filterModel,filterCallback}">
                    <InputText type="text" v-model="filterModel.value" @keydown.enter="filterCallback()" class="p-column-filter" placeholder="コード" />
                    </template>
                </Column>                    
                <Column field="info_source" header="情報源" :sortable="true"></Column>
                <Column field="theme_desc" header="テーマ説明" :sortable="true"></Column>
                <Column field="r_date" header="レコード更新日" :sortable="true"></Column>
                <Column field="r_desc" header="レコード更新理由" :sortable="true"></Column>
                </DataTable>
            </div>
        </div>
    </div>
</template>

<script>
import ThemeService from '@/service/ThemeService';

export default {
    data() {
        return {
            loading: false,
            totalRecords: 0,
            themes: null,
            lazyParams: {},
            filters1: {},
            filters: {
                'theme_name': {value: '', matchMode: 'contains'},
                'meigara_cd_list': {value: '', matchMode: 'contains'},
            },
            perf: null,     
        }
    },
    themeService: null,
    created() {
        this.themeService = new ThemeService();
    },
    mounted() {
        this.loading = true;

        this.lazyParams = {
            first: 0,
            rows: this.$refs.dt.rows,
            sortField: "id",
            sortOrder: "-1",
            filters: this.filters            
        };

        this.loadLazyData();
    },
    methods: {
        loadLazyData() {
            this.loading = true;

            setTimeout(() => {
                this.themeService.getAll(
                    {dt_params: JSON.stringify( this.lazyParams )})
                        .then(data => {
                            this.themes = data.payload.data;
                            this.totalRecords = data.payload.total;
                            this.loading = false;
                            this.perf = data.perf;
                    }
                );
            }, Math.random() * 1000 + 250);
        },
        onPage(event) {
            this.lazyParams = event;
            this.loadLazyData();
        },
        onSort(event) {
            this.lazyParams = event;
            this.loadLazyData();
        },
        onFilter() {
            this.lazyParams.filters = this.filters;
            this.loadLazyData();
        }
    }
}
</script>

<style scoped>

</style>